import React, { Component } from "react";
import { message, Row, Col, Spin, Popconfirm } from "antd";
import { Form, FormItem, InputItem, InputNumberItem, ButtonItem, ErrorItem } from "../../../../Components/Items";
import axios from "axios";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import { connect } from "react-redux";

const TIPOS_MOVIMIENTO_INVENTARIO = [
  { codigo: "101", nombre: "Entrada por compra", serieDefault: "EC" },
  { codigo: "102", nombre: "Reversa entrada", serieDefault: "RE" },
  { codigo: "103", nombre: "Entrada por cambio de insumo", serieDefault: "ECI" },
  { codigo: "201", nombre: "Salida a centro de costos", serieDefault: "SCC" },
  { codigo: "261", nombre: "Consumo a producción", serieDefault: "CP" },
  { codigo: "301", nombre: "Transferencia entre almacenes", serieDefault: "TA" },
  { codigo: "311", nombre: "Cambio ubicación", serieDefault: "CU" },
  { codigo: "601", nombre: "Salida por venta", serieDefault: "SV" },
  { codigo: "602", nombre: "Salida por cambio de insumo", serieDefault: "SCI" },
  { codigo: "651", nombre: "Salida devolución", serieDefault: "SD" },
  { codigo: "701", nombre: "Ajuste positivo inventario", serieDefault: "AP" },
  { codigo: "702", nombre: "Ajuste negativo inventario", serieDefault: "AN" },
];

class SeriesFoliosConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
  };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  async consultarConfiguracion() {
    this.setState({ loading: true });
    await axios
      .post(
        "empresas/selectConfiguracionNumeracion",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
          this.formRef.current.setFieldsValue({
            serieFacturas: res.data.serieFacturas,
            folioFacturas: res.data.folioFacturas,
            serieRemisiones: res.data.serieRemisiones,
            folioRemisiones: res.data.folioRemisiones,
            serieCartaPorte: res.data.serieCartaPorte,
            folioCartaPorte: res.data.folioCartaPorte,
            serieFacturaGlobal: res.data.serieFacturaGlobal,
            folioFacturaGlobal: res.data.folioFacturaGlobal,
            serieEmbarques: res.data.serieEmbarques,
            folioEmbarques: res.data.folioEmbarques,
            serieOrdenesCompra: res.data.serieOrdenesCompra,
            folioOrdenesCompra: res.data.folioOrdenesCompra,
            serieComodato: res.data.serieComodato,
            folioComodato: res.data.folioComodato,
            serieMovimientoInventario: res.data.serieMovimientoInventario,
            folioMovimientoInventario: res.data.folioMovimientoInventario,
            serieTraspasosAlmacenes: res.data.serieTraspasosAlmacenes,
            folioTraspasosAlmacenes: res.data.folioTraspasosAlmacenes,
            seriePreCotizacionesIngenieria: res.data.seriePreCotizacionesIngenieria,
            folioPreCotizacionesIngenieria: res.data.folioPreCotizacionesIngenieria,
            serieOrdenesProduccionPU: res.data.serieOrdenesProduccionPU,
            folioOrdenesProduccionPU: res.data.folioOrdenesProduccionPU,
            seriesFoliosTipoMovimientoInventario:
              res.data.seriesFoliosTipoMovimientoInventario || {},
          });
        }
      });
    this.setState({ loading: false });
  }

  async actualizarTipoMovimientoInventario(codigo) {
    const seriePath = ["seriesFoliosTipoMovimientoInventario", codigo, "serie"];
    const folioPath = ["seriesFoliosTipoMovimientoInventario", codigo, "folio"];
    try {
      await this.formRef.current.validateFields([seriePath, folioPath]);
    } catch (e) {
      ErrorItem(e);
      return;
    }
    const serie = this.formRef.current.getFieldValue(seriePath);
    const folio = this.formRef.current.getFieldValue(folioPath);
    this.setState({ loading: true });
    axios
      .post(
        "empresas/editarConfiguracionNumeracion",
        {
          seriesFoliosTipoMovimientoInventario: {
            [codigo]: { serie, folio },
          },
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }

  async actualizarPar(serieField, folioField) {
    try {
      await this.formRef.current.validateFields([serieField, folioField]);
    } catch (e) {
      ErrorItem(e);
      return;
    }
    const values = this.formRef.current.getFieldsValue([serieField, folioField]);
    this.setState({ loading: true });
    axios
      .post(
        "empresas/editarConfiguracionNumeracion",
        {
          [serieField]: values[serieField],
          [folioField]: values[folioField],
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }

  botonActualizar(serieField, folioField) {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
        <Popconfirm
          title="¿Seguro que quieres actualizar esta serie y folio?"
          onConfirm={() => this.actualizarPar(serieField, folioField)}
          okText="Si"
          cancelText="No"
        >
          <ButtonItem
            cyan
            type="primary"
            style={{ minWidth: 120, height: 30, display: "flex", justifyContent: "center" }}
          >
            Actualizar
          </ButtonItem>
        </Popconfirm>
      </div>
    );
  }

  render() {

    return (
      <>
        <Spin spinning={this.state.loading}>
          <Form
            name="seriesFoliosConfiguracion"
            layout="vertical"
            ref={this.formRef}
          >
            <Row gutter={[16, 16]}>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Facturas">
                  <FormItem
                    name="serieFacturas"
                    label="Serie Facturas"
                    tooltip={{ title: "Serie que se mostrara en facturas." }}
                    required
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en facturas" />
                  </FormItem>

                  <FormItem
                    name="folioFacturas"
                    label="Folio Facturas"
                    tooltip={{ title: "Folio de la siguiente factura." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio de la siguiente factura"
                    />
                  </FormItem>
                  {this.botonActualizar("serieFacturas", "folioFacturas")}
                </DynamicCardForm>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Remisiones">
                  <FormItem
                    name="serieRemisiones"
                    label="Serie Remisiones"
                    tooltip={{ title: "Serie que se mostrara en remisiones." }}
                    required
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en remisiones" />
                  </FormItem>

                  <FormItem
                    name="folioRemisiones"
                    label="Folio Remisiones"
                    tooltip={{ title: "Folio de la siguiente remision." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio de la siguiente remision"
                    />
                  </FormItem>
                  {this.botonActualizar("serieRemisiones", "folioRemisiones")}
                </DynamicCardForm>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Carta Porte">
                  <FormItem
                    name="serieCartaPorte"
                    label="Serie Carta Porte"
                    tooltip={{ title: "Serie que se mostrara en carta porte." }}
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en carta porte" />
                  </FormItem>

                  <FormItem
                    name="folioCartaPorte"
                    label="Folio Carta Porte"
                    tooltip={{ title: "Folio de la siguiente carta porte." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio de la siguiente carta porte"
                    />
                  </FormItem>
                  {this.botonActualizar("serieCartaPorte", "folioCartaPorte")}
                </DynamicCardForm>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Factura Global">
                  <FormItem
                    name="serieFacturaGlobal"
                    label="Serie Factura Global"
                    tooltip={{ title: "Serie que se mostrara en factura global." }}
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en factura global" />
                  </FormItem>

                  <FormItem
                    name="folioFacturaGlobal"
                    label="Folio Factura Global"
                    tooltip={{ title: "Folio de la siguiente factura global." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio de la siguiente factura global"
                    />
                  </FormItem>
                  {this.botonActualizar("serieFacturaGlobal", "folioFacturaGlobal")}
                </DynamicCardForm>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Embarques">
                  <FormItem
                    name="serieEmbarques"
                    label="Serie Embarques"
                    tooltip={{ title: "Serie que se mostrara en embarques." }}
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en embarques" />
                  </FormItem>

                  <FormItem
                    name="folioEmbarques"
                    label="Folio Embarques"
                    tooltip={{ title: "Folio del siguiente embarque." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio del siguiente embarque"
                    />
                  </FormItem>
                  {this.botonActualizar("serieEmbarques", "folioEmbarques")}
                </DynamicCardForm>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Órdenes de Compra">
                  <FormItem
                    name="serieOrdenesCompra"
                    label="Serie Órdenes de Compra"
                    tooltip={{ title: "Serie que se mostrara en órdenes de compra." }}
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en órdenes de compra" />
                  </FormItem>

                  <FormItem
                    name="folioOrdenesCompra"
                    label="Folio Órdenes de Compra"
                    tooltip={{ title: "Folio de la siguiente orden de compra." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio de la siguiente orden de compra"
                    />
                  </FormItem>
                  {this.botonActualizar("serieOrdenesCompra", "folioOrdenesCompra")}
                </DynamicCardForm>
              </Col>

              {this.props.preCotizacionIngenieria && (
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                  <DynamicCardForm title="Numeración Pre-cotizaciones">
                    <FormItem
                      name="seriePreCotizacionesIngenieria"
                      label="Serie Pre-cotizaciones"
                      tooltip={{ title: "Serie que se mostrara en pre-cotizaciones por ingeniería." }}
                      margin
                    >
                      <InputItem placeholder="Serie que se mostrara en pre-cotizaciones" />
                    </FormItem>

                    <FormItem
                      name="folioPreCotizacionesIngenieria"
                      label="Folio Pre-cotizaciones"
                      tooltip={{ title: "Folio de la siguiente pre-cotización." }}
                      margin
                    >
                      <InputNumberItem
                        min={1}
                        placeholder="Folio de la siguiente pre-cotización"
                      />
                    </FormItem>
                    {this.botonActualizar("seriePreCotizacionesIngenieria", "folioPreCotizacionesIngenieria")}
                  </DynamicCardForm>
                </Col>
              )}

              {this.props.ordenesMaquila && (
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                  <DynamicCardForm title="Numeración Órdenes de Maquila">
                    <FormItem
                      name="serieOrdenesProduccionPU"
                      label="Serie Órdenes de Maquila"
                      tooltip={{ title: "Serie que se mostrara en órdenes de maquila." }}
                      margin
                    >
                      <InputItem placeholder="Serie que se mostrara en órdenes de maquila" />
                    </FormItem>

                    <FormItem
                      name="folioOrdenesProduccionPU"
                      label="Folio Órdenes de Maquila"
                      tooltip={{ title: "Folio de la siguiente orden de maquila. Si el proyecto tiene numeración propia, se usa la del proyecto." }}
                      margin
                    >
                      <InputNumberItem
                        min={1}
                        placeholder="Folio de la siguiente orden de maquila"
                      />
                    </FormItem>
                    {this.botonActualizar("serieOrdenesProduccionPU", "folioOrdenesProduccionPU")}
                  </DynamicCardForm>
                </Col>
              )}

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Comodato">
                  <FormItem
                    name="serieComodato"
                    label="Serie Comodato"
                    tooltip={{ title: "Serie que se mostrara en comodato." }}
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en comodato" />
                  </FormItem>

                  <FormItem
                    name="folioComodato"
                    label="Folio Comodato"
                    tooltip={{ title: "Folio del siguiente comodato." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio del siguiente comodato"
                    />
                  </FormItem>
                  {this.botonActualizar("serieComodato", "folioComodato")}
                </DynamicCardForm>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Movimiento de Inventario">
                  <FormItem
                    name="serieMovimientoInventario"
                    label="Serie Movimiento de Inventario"
                    tooltip={{ title: "Serie que se mostrara en movimientos de inventario." }}
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en movimientos de inventario" />
                  </FormItem>

                  <FormItem
                    name="folioMovimientoInventario"
                    label="Folio Movimiento de Inventario"
                    tooltip={{ title: "Folio del siguiente movimiento de inventario." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio del siguiente movimiento de inventario"
                    />
                  </FormItem>
                  {this.botonActualizar("serieMovimientoInventario", "folioMovimientoInventario")}
                </DynamicCardForm>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <DynamicCardForm title="Numeración Traspasos de Almacenes">
                  <FormItem
                    name="serieTraspasosAlmacenes"
                    label="Serie Traspasos de Almacenes"
                    tooltip={{ title: "Serie que se mostrara en traspasos de almacenes." }}
                    margin
                  >
                    <InputItem placeholder="Serie que se mostrara en traspasos de almacenes" />
                  </FormItem>

                  <FormItem
                    name="folioTraspasosAlmacenes"
                    label="Folio Traspasos de Almacenes"
                    tooltip={{ title: "Folio del siguiente traspaso de almacenes." }}
                    margin
                  >
                    <InputNumberItem
                      min={1}
                      placeholder="Folio del siguiente traspaso de almacenes"
                    />
                  </FormItem>
                  {this.botonActualizar("serieTraspasosAlmacenes", "folioTraspasosAlmacenes")}
                </DynamicCardForm>
              </Col>

              <Col xs={24}>
                <DynamicCardForm title="Numeración por Tipo de Movimiento de Inventario">
                  {TIPOS_MOVIMIENTO_INVENTARIO.map((tipo) => (
                    <Row
                      key={tipo.codigo}
                      gutter={[12, 0]}
                      align="middle"
                      style={{ marginBottom: 4 }}
                    >
                      <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                        <div style={{ fontWeight: 500 }}>
                          {tipo.codigo} - {tipo.nombre}
                        </div>
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                        <FormItem
                          name={["seriesFoliosTipoMovimientoInventario", tipo.codigo, "serie"]}
                          tooltip={{ title: `Serie del tipo ${tipo.codigo}. Default: ${tipo.serieDefault}.` }}
                        >
                          <InputItem placeholder={`Serie (${tipo.serieDefault})`} />
                        </FormItem>
                      </Col>
                      <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                        <FormItem
                          name={["seriesFoliosTipoMovimientoInventario", tipo.codigo, "folio"]}
                          tooltip={{ title: `Folio del siguiente movimiento de tipo ${tipo.codigo}.` }}
                        >
                          <InputNumberItem min={1} placeholder="Folio" style={{ width: "100%" }} />
                        </FormItem>
                      </Col>
                      <Col xs={24} sm={4} md={4} lg={4} xl={4}>
                        <Popconfirm
                          title="¿Seguro que quieres actualizar esta serie y folio?"
                          onConfirm={() => this.actualizarTipoMovimientoInventario(tipo.codigo)}
                          okText="Si"
                          cancelText="No"
                        >
                          <ButtonItem
                            cyan
                            type="primary"
                            style={{ width: "100%", height: 30, display: "flex", justifyContent: "center" }}
                          >
                            Actualizar
                          </ButtonItem>
                        </Popconfirm>
                      </Col>
                    </Row>
                  ))}
                </DynamicCardForm>
              </Col>

            </Row>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    preCotizacionIngenieria: state.empresa.preCotizacionIngenieria,
    ordenesMaquila: state.empresa.ordenesMaquila,
  };
};

export default connect(mapStateToProps)(SeriesFoliosConfiguracion);
